// 1. Initialize Shopify Object
window.Shopify = window.Shopify || {};
window.Shopify.getCart = window.Shopify.getCart || function(callback, cart) {
  if (!cart) {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        if (typeof callback === 'function') callback(data);
        else if (typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate(data);
      })
      .catch(err => console.error('Error fetching cart:', err));
  } else {
    if (typeof callback === 'function') callback(cart);
    else if (typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate(cart);
  }
};

// 2. Global Variables & Cached Selectors
let flkty;
const productVariants = window.productVariants || [];
const productOptions = window.productOptions || [];
const variantRadioButtons = document.querySelectorAll('.variant-radio');
const variantSelects = document.querySelectorAll('.variant-option');
const cartSection = document.querySelector('.drawer .js-contents');

// 3. Helper Functions
function findSelectedVariant(variants, selectedValues) {
  const selectedValuesString = selectedValues.join(',');
  return variants.find(variant => variant.options.join(',') === selectedValuesString);
}

function hideCompareAtPriceElement(selectedVariant) {
  const productAction = document.querySelector('.product-action');
  if (!productAction) return;
  
  if (selectedVariant.compare_at_price <= 0) {
    productAction.classList.add('hide_compare_at');
  } else {
    productAction.classList.remove('hide_compare_at');
  }
}

function addToCartButton($addButton, $addButtonStatus, selectedVariant) {
  if (!$addButton) return;
  const state = getVariantAvailabilityState(selectedVariant); // Assuming this is defined elsewhere
  const span = $addButton.querySelector('span');

  if (!$addButtonStatus || state === 2) {
    $addButton.disabled = true;
    $addButton.classList.add('disabled');
    $addButton.classList.remove('preorder');
    if (span) span.innerHTML = "Sold Out";
    return;
  }

  $addButton.disabled = false;
  $addButton.classList.remove('disabled');

  switch (state) {
    case 1:
    case 4:
      $addButton.classList.remove('preorder');
      if (span) span.innerHTML = "Add to Cart";
      break;
    case 3:
      $addButton.classList.add('preorder');
      if (span) span.innerHTML = "Pre Order";
      break;
  }
}

function updateURL(selectedVariant) {
  window.history.replaceState(null, null, `?variant=${selectedVariant.id}`);
}

function updateHiddenInput(selectedVariant, $hiddenInput) {
  if ($hiddenInput) $hiddenInput.value = selectedVariant.id;
  const updateButtonFrom = document.querySelector('form.buttonproduct input.product-variant-id');
  if (updateButtonFrom) updateButtonFrom.value = selectedVariant.id;
}

function setQuantityInputValue(selectedVariant, $quantityInput) {
  if (!$quantityInput) return;
  $quantityInput.value = 1;
  let setUpdatedQuantity = selectedVariant.inventory_quantity;
  if (setUpdatedQuantity <= 0 && selectedVariant.inventory_policy === 'continue') {
    setUpdatedQuantity = 12;
  }
  $quantityInput.setAttribute("max", setUpdatedQuantity);
}

function updateMedia(selectedVariant) {
  if (!selectedVariant?.featured_media) return;
  const current_media_id = selectedVariant.featured_media.id;

  const imageSlider = document.querySelector('.product__image-slider');
  if (imageSlider && flkty) {
    const images = imageSlider.querySelectorAll("img");
    const media_id_array = Array.from(images).map(img => parseInt(img.getAttribute('data-media-id')));
    const index = media_id_array.indexOf(current_media_id);
    if (index !== -1) flkty.select(index);
  } else {
    const mediaList = document.querySelector('.product__media-list');
    if (mediaList) {
      Array.from(mediaList.children).forEach(child => {
        child.style.display = child.getAttribute('data-media-id').includes(current_media_id) ? "block" : "none";
      });
    }
  }
}

function changePrice(selectedVariant, variantNewPrice, variantCent, variantOldPrice, percentOff, $afterpay, $priceDiff) {
  let globalProductVariantPrice = 0;
  let globalProductOldPrice = 0;

  // Main Price
  if ((selectedVariant.price / 100) % 1 === 0) {
    globalProductVariantPrice = (selectedVariant.price / 100).toFixed(0);
    if (variantNewPrice) variantNewPrice.innerHTML = globalProductVariantPrice;
    if (variantCent) variantCent.style.display = 'none';
  } else {
    globalProductVariantPrice = (selectedVariant.price / 100).toFixed(2);
    if (variantCent) {
      variantCent.style.display = 'block';
      variantCent.innerHTML = '.' + globalProductVariantPrice.split('.')[1];
    }
    if (variantNewPrice) {
      variantNewPrice.innerHTML = globalProductVariantPrice.split('.')[0];
    }
  }

  // Compare-At Price
  if (selectedVariant.compare_at_price > 0) {
    globalProductOldPrice = (selectedVariant.compare_at_price / 100).toFixed((selectedVariant.compare_at_price / 100) % 1 === 0 ? 0 : 2);
    if (variantOldPrice) variantOldPrice.innerHTML = '$' + globalProductOldPrice;
  } else {
    globalProductOldPrice = globalProductVariantPrice;
  }

  // Savings
  if ($priceDiff && parseFloat(globalProductOldPrice) > parseFloat(globalProductVariantPrice)) {
    $priceDiff.innerHTML = '$' + twoDigitDecimals((globalProductOldPrice * 100) - (globalProductVariantPrice * 100));
  }

  // Percentage Off
  if (percentOff.length > 0 && selectedVariant.compare_at_price > selectedVariant.price) {
    const getpercentOff = ((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100;
    const percentInt = getpercentOff.toString().split('.')[0];
    
    percentOff.forEach(el => { if (el) el.innerHTML = percentInt; });
    
    const topPercentOff = document.querySelector('.product_displaytag .toppercentoff .js-percent-off');
    if (topPercentOff) topPercentOff.innerHTML = percentInt;
  }

  // Afterpay
  if ($afterpay) {
    $afterpay.innerHTML = '$' + (selectedVariant.price / 400).toFixed(2);
  }

  // Confirmation Title
  const confirmationTitle = document.querySelector('.please_select_size .customerSelectedSize');
  if (confirmationTitle) confirmationTitle.innerHTML = selectedVariant.title;
}

function twoDigitDecimals(num) {
  return ((num / 100) % 1 === 0) ? (num / 100).toFixed(0) : (num / 100).toFixed(2);
}

function addCommas(num) {
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join('.');
}

function openProductReview() {
  const targetDiv = document.querySelector('.newbottomreview');
  if (targetDiv) {
    setTimeout(() => {
      targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  }
}

function zoom(e) {
  if (window.innerWidth <= 992) return;
  const zoomer = e.currentTarget;
  let offsetX, offsetY;

  if (e.type === 'touchmove') {
    offsetX = e.touches[0].pageX;
    offsetY = e.touches[0].pageY;
  } else {
    const rect = zoomer.getBoundingClientRect();
    offsetX = e.offsetX || e.clientX - rect.left;
    offsetY = e.offsetY || e.clientY - rect.top;
  }

  const x = (offsetX / zoomer.offsetWidth) * 100;
  const y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = `${x}% ${y}%`;
}

// 4. Core Variant Logic
function handleVariantChange() {
  const selectedValues = [];
  const selectedOptions = {};
  const clickedElement = this;

  // Visual active state update
  if (clickedElement?.tagName?.toLowerCase() === 'input' && clickedElement.type === 'radio') {
    const posRelative = clickedElement.closest('.pos_relative');
    clickedElement.closest('.radio-option').querySelectorAll('label').forEach(lbl => lbl.classList.remove('active'));
    if (posRelative) posRelative.querySelector('label')?.classList.add('active');
  }

  // Gather current values
  variantRadioButtons.forEach(radio => {
    if (radio.checked) selectedOptions[radio.dataset.optionName || radio.name] = radio.value;
  });
  variantSelects.forEach((select, index) => {
    selectedOptions[select.name || productOptions[index]] = select.value;
  });

  // Auto-correction for out of stock combinations
  const currentValuesArray = productOptions.map(opt => selectedOptions[opt]);
  const currentVariant = findSelectedVariant(productVariants, currentValuesArray);

  if (!currentVariant || (currentVariant.inventory_quantity <= 0 && currentVariant.inventory_policy === 'deny')) {
    const clickedOptionName = clickedElement?.dataset?.optionName || clickedElement?.name || null;

    productOptions.forEach(optName => {
      if (optName !== clickedOptionName) {
        const availableVariant = productVariants.find(v => {
          const matchesClicked = !clickedOptionName || v[`option${productOptions.indexOf(clickedOptionName) + 1}`] === selectedOptions[clickedOptionName];
          return matchesClicked && (v.inventory_quantity > 0 || v.inventory_policy !== 'deny');
        });

        if (availableVariant) {
          const optIndex = productOptions.indexOf(optName);
          const newOptValue = availableVariant[`option${optIndex + 1}`];
          selectedOptions[optName] = newOptValue;

          const targetRadio = Array.from(variantRadioButtons).find(r => (r.dataset.optionName || r.name) === optName && r.value === newOptValue);
          if (targetRadio) {
            variantRadioButtons.forEach(r => {
              if ((r.dataset.optionName || r.name) === optName) {
                r.checked = false;
                r.closest('.pos_relative')?.querySelector('label')?.classList.remove('active');
              }
            });
            targetRadio.checked = true;
            targetRadio.closest('.pos_relative')?.querySelector('label')?.classList.add('active');
          }
        }
      }
    });
  }

  // Evaluate final availability
  variantRadioButtons.forEach(radio => {
    const optionName = radio.dataset.optionName || radio.name;
    const testOptions = { ...selectedOptions, [optionName]: radio.value };
    const testVariant = findSelectedVariant(productVariants, productOptions.map(opt => testOptions[opt]));
    const label = radio.closest('.pos_relative')?.querySelector('label');
    const isFirstOption = (optionName === productOptions[0]);

    if (!testVariant || (testVariant.inventory_quantity <= 0 && testVariant.inventory_policy === 'deny')) {
      if (label) label.classList.add('outofstock');
      radio.disabled = !isFirstOption;
    } else {
      if (label) label.classList.remove('outofstock');
      radio.disabled = false;
    }
  });

  // Update DOM
  productOptions.forEach(opt => {
    if (selectedOptions[opt]) selectedValues.push(selectedOptions[opt]);
  });

  const selectedVariant = findSelectedVariant(productVariants, selectedValues);
  if (selectedVariant) {
    const $form = clickedElement.closest ? (clickedElement.closest(".globalatc") || document.querySelector(".globalatc")) : document.querySelector(".globalatc");
    const $hiddenInput = $form ? $form.querySelector("form input.hiddenform") : document.querySelector("input.hiddenform");
    const $quantityInput = document.querySelector(".product-form__buttons input.quntityInput");
    const variantNewPrice = $form?.querySelector(".price_diff .formattedMainPrice");
    const variantCent = $form?.querySelector(".price_diff .formattedCentsPrice");
    const variantOldPrice = $form?.querySelector("span.js-old-price");
    const percentOff = $form ? $form.querySelectorAll(".js-percent-off") : [];
    
    let $addButton = document.querySelector(".product-form__buttons button.addToCartBtn") || document.querySelector(".add-to-cart-gift-form");
    
    const $addButtonStatus = selectedVariant.inventory_quantity > 0 || selectedVariant.inventory_policy !== 'deny';
    const $afterpay = $form?.querySelector("span.js-afterpay-payments");
    const $priceDiff = $form?.querySelector("span.js-save");

    addToCartButton($addButton, $addButtonStatus, selectedVariant);
    updateURL(selectedVariant);
    if ($hiddenInput) updateHiddenInput(selectedVariant, $hiddenInput);
    if ($quantityInput) setQuantityInputValue(selectedVariant, $quantityInput);
    
    changePrice(selectedVariant, variantNewPrice, variantCent, variantOldPrice, percentOff, $afterpay, $priceDiff);
    hideCompareAtPriceElement(selectedVariant);
    updateMedia(selectedVariant);

    const colorNameEl = $form?.querySelector('.js-color-name');
    if (colorNameEl && productOptions) {
      const colorIndex = productOptions.findIndex(opt => opt.toLowerCase().includes('colour') || opt.toLowerCase().includes('color'));
      if (colorIndex !== -1 && selectedVariant[`option${colorIndex + 1}`]) {
        colorNameEl.textContent = selectedVariant[`option${colorIndex + 1}`];
      }
    }
  }
}

// 5. AJAX Cart Handling Object
const ajaxify = {
  onAddToCart: function(event) {
    event.preventDefault();
    if (this.classList.contains('yes')) {
      const pleaseSelect = this.closest('.please_select_size');
      if (pleaseSelect) pleaseSelect.style.display = 'none';
      
      const mainAtcBtn = document.querySelector('.add-to-cart button.addToCartBtn');
      if (mainAtcBtn) {
        mainAtcBtn.classList.remove('js-disabled-add-to-cart');
        mainAtcBtn.click();
        setTimeout(() => mainAtcBtn.classList.add('js-disabled-add-to-cart'), 400);
      }
    }
  },

  onCartUpdated: function() {
    fetch('/cart', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => response.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const cartItems = tempDiv.querySelector('.header #cart-icon-bubble');
        const cartContents = tempDiv.querySelector('.js-contents');

        // Replaced jQuery with Vanilla JS for efficiency
        const drawerContents = document.querySelector('.drawer__contents');
        if (drawerContents && cartContents) drawerContents.innerHTML = cartContents.innerHTML;
        
        const cartErrors = document.getElementById('CartDrawer-CartErrors');
        if (cartErrors) cartErrors.innerHTML = '';
        
        document.querySelector('.drawer')?.classList.remove('is-empty');
        document.querySelector('.drawer__inner-empty') && (document.querySelector('.drawer__inner-empty').style.display = 'none');
        document.querySelector('cart-drawer-items') && (document.querySelector('cart-drawer-items').className = '');
        
        const checkoutBtn = document.getElementById('CartDrawer-Checkout');
        if (checkoutBtn) checkoutBtn.disabled = false;

        fetch("/cart.js")
          .then(res => res.json())
          .then(cart => {
            const headerIcon = document.querySelector('.header #cart-icon-bubble');
            if (headerIcon && cartItems) headerIcon.innerHTML = cartItems.innerHTML;

            const globalLoading = document.querySelector('.global_quantity_selector .add-to-cart');
            if (globalLoading) globalLoading.classList.remove('loadingAnimation');

            let itemSubtoTotalPrice = (cart.items_subtotal_price / 100).toFixed((cart.items_subtotal_price / 100) % 1 === 0 ? 0 : 2);
            
            const subtotalValue = document.querySelector('cart-drawer p.totals__subtotal-value');
            if (subtotalValue) subtotalValue.innerHTML = `$${addCommas(itemSubtoTotalPrice)} AUD`;

            const shippingStatus = document.querySelector('cart-drawer .shippingstatus');
            if (shippingStatus) {
              shippingStatus.innerHTML = parseFloat(itemSubtoTotalPrice) >= 150 ? 'Free' : '$9.95';
            }
          });

        if (cartSection && cartContents) cartSection.innerHTML = cartContents.innerHTML;         
        document.querySelector('.drawer')?.classList.add('active');
      })
      .catch(error => alert(error));
  },

  init: function() {
    const confirmYes = document.querySelector('.confirm_select_size button.yes');
    if (confirmYes) confirmYes.addEventListener('click', ajaxify.onAddToCart);
  }
};

// 6. Main DOM Initialization
document.addEventListener('DOMContentLoaded', () => {
  
  // Initialize Flickity
  if (document.querySelector('.product__image-slider')) {
    flkty = new Flickity('.product__image-slider', { contain: true, wrapAround: true, pageDots: false });
  }

  // Event Listeners for Variants
  variantRadioButtons.forEach(radio => radio.addEventListener('click', handleVariantChange));
  variantSelects.forEach(select => select.addEventListener('change', handleVariantChange));

  // Gift Form AJAX Cart
  const giftForm = document.querySelector('.product_mainform');
  const giftSubmitButton = giftForm?.querySelector('.add-to-cart-gift-form');

  if (giftForm && giftSubmitButton) {
    giftForm.addEventListener('submit', (e) => {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(giftForm),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(res => res.json())
      .then(sections => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer?.renderContents) {
          cartDrawer.renderContents({ id: Date.now(), sections: sections });
          setTimeout(() => {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
            const emptyMessage = cartDrawer.querySelector('.drawer__inner-empty');
            if (emptyMessage) emptyMessage.style.display = 'none';
            cartDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
            cartDrawer.classList.add('active');
            document.body.classList.add('overflow-hidden');
          }, 50);
        }
      })
      .catch(err => console.error('Error handling cart drawer update:', err));
    });
  }

  // Quantity Picker
  const input = document.querySelector('.quantity-selector input.quantity__input');
  document.querySelectorAll('.quantity-selector span.quantitybutton').forEach(qp => {
    qp.addEventListener('click', function(e) {
      e.preventDefault();
      if (!input) return;
      let currentVal = parseInt(input.value);
      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || 999;

      if (this.classList.contains("quantity_minus")) {
        if (currentVal > min) input.value = currentVal - 1;
        this.disabled = (parseInt(input.value) <= min);
        this.closest('.quantity-selector').querySelector('.quantity_plus').removeAttribute("disabled");
      } else if (this.classList.contains("quantity_plus")) {
        if (currentVal < max) input.value = currentVal + 1;
        this.disabled = (parseInt(input.value) >= max);
        this.closest('.quantity-selector').querySelector('.quantity_minus').removeAttribute("disabled");
      }
    });
  });

  // UI Delays & Interactions
  setTimeout(() => {
    const thumb = document.querySelector(".product__image-thumbnail");
    if (thumb) thumb.style.opacity = 1;
  }, 500);

  setTimeout(() => {
    document.querySelectorAll('.flickity-button').forEach(btn => btn.style.opacity = 1);
  }, 100);

  // Add To Cart Button Loading
  const productATCBtn = document.querySelector('.product-action .add_btn');
  if (productATCBtn) {
    productATCBtn.addEventListener('click', function() {
      const loadingButtonEl = this.querySelector('.custom-loading');
      if (loadingButtonEl) loadingButtonEl.classList.remove('hidden');
      fetch('/cart.js').then(() => {
        setTimeout(() => { if (loadingButtonEl) loadingButtonEl.classList.add('hidden'); }, 600);
      });
    });
  }

  // Reviews Jump
  document.querySelectorAll('.jumpsection a.mainproductreviews').forEach(element => {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      const isCompact = this.closest('body').classList.contains('compact');
      if (isCompact) {
        document.querySelector('body.compact .product_dropdown h2#title-r')?.closest('.content_block')?.classList.add('active');
      } else {
        document.querySelector('.product_dropdown .titles .title.review')?.click();
      }
      openProductReview();
    });
  });

  // Restore Click-to-Popup Zoom
  const productZoomIcon = document.querySelector('.customimagezoom');
  if (productZoomIcon) {
    productZoomIcon.addEventListener('click', function(e) {
      e.preventDefault();
      // Look for the lightbox link inside the active slide
      const activeSlide = document.querySelector('.product__image-slider .is-selected') || document.querySelector('.img_producto_container');
      const activeZoomLink = activeSlide?.querySelector('a.fslightbox');
      
      if (activeZoomLink) {
        activeZoomLink.click();
      } else {
        console.warn("Zoom icon clicked, but no fslightbox link was found.");
      }
    });
  }

  // Image Zoom
  document.querySelectorAll('.img_producto_container').forEach(container => {
    const imgUrl = container.getAttribute('data-img');
    const zoomImg = container.querySelector('img.zoomimg');
    if (imgUrl) {
      container.style.backgroundImage = `url(${imgUrl})`;
      container.addEventListener('mousemove', (e) => {
        zoom(e);
        if (zoomImg) zoomImg.style.opacity = 0;
      });
      container.addEventListener('mouseleave', () => {
        if (zoomImg) zoomImg.style.opacity = 1;
      });
    }
  });

  // Product Description Tabs
  const titles = document.querySelectorAll('.product-description-tab .title');
  const texts = document.querySelectorAll('.text');
  titles.forEach(title => {
    title.addEventListener('click', function() {
      if (this.classList.contains('help')) return;
      const id = this.id.split('-')[1];
      texts.forEach(text => text.style.display = (text.id === `text-${id}`) ? 'block' : 'none');
      titles.forEach(t => t.classList.remove('title-active'));
      this.classList.add('title-active');
    });
  });

  // Append PF Description
  const pf = document.querySelector('#__pf');
  const productBottom = document.querySelector('.product-description-tab .product-description');
  if (pf && productBottom) productBottom.appendChild(pf);

  // Confirmation Messages
  document.querySelectorAll("button.js-disabled-add-to-cart").forEach(button => {
    button.addEventListener("click", function(event) {
      event.preventDefault();
      document.querySelectorAll('.add_btn button.js-add-to-cart-button').forEach(btn => btn.style.color = 'white');
      const displaySelectMsg = document.querySelector('.please_select_size');
      if (displaySelectMsg) displaySelectMsg.style.display = 'block';
    });
  });

  const confirmNoBtn = document.querySelector('.confirm_select_size button.no');
  if (confirmNoBtn) {
    confirmNoBtn.addEventListener("click", function(e) {
      e.preventDefault();
      const parent = this.closest('.please_select_size');
      if (parent) parent.style.display = 'none';
    });
  }

  // Init Ajaxify
  ajaxify.init();
});